// extracted by mini-css-extract-plugin
export var bottomLinks = "Footer-module--bottomLinks--0ca3a";
export var bottomText = "Footer-module--bottomText--0b65e";
export var footer = "Footer-module--footer--47ac5";
export var logo = "Footer-module--logo--703eb";
export var pmLogoFooter = "Footer-module--pmLogoFooter--4a6d3";
export var vaihe = "Footer-module--vaihe--73a1f";
export var wrapper = "Footer-module--wrapper--c1618";